import facilityHome from '@/components/jm/facility/home.vue'
//设备合同管理
import macOrderHome from '@/components/jm/facility/macOrder/home.vue'
import macOrderList from '@/components/jm/facility/macOrder/list.vue'
//设备合同详情
import macOrderDetailsHome from '@/components/jm/facility/macOrder/details/home.vue'
import macOrderDetailsList from '@/components/jm/facility/macOrder/details/list.vue'
//设备信息
import macOrderMacHome from '@/components/jm/facility/macOrder/mac/home.vue'
import macOrderMacList from '@/components/jm/facility/macOrder/mac/list.vue'
export default [{
	path: 'facility',
	name: 'facility',
	component: facilityHome,
	children: [{ //设备订单信息
		path: 'macOrder',
		name: 'macOrder',
		component: macOrderHome,
		children: [{
			path: 'list',
			name: 'jm/facility/macOrder/list',
			component: macOrderList
		}]
	}, { //设备订单详情
		path: 'macOrderDetails',
		name: 'macOrderDetails',
		component: macOrderDetailsHome,
		children: [{
			path: 'list',
			name: 'jm/facility/macOrder/details/list',
			component: macOrderDetailsList
		}]
	}, { //设备设备信息
		path: 'macOrderMac',
		name: 'macOrderMac',
		component: macOrderMacHome,
		children: [{
			path: 'list',
			name: 'jm/facility/macOrder/mac/list',
			component: macOrderMacList
		}]
	}]
}]



// WEBPACK FOOTER //
// ./src/router/jm/facility/facility.js